import { useAnalytics, useUserTracking } from '@growdash/analytics';
import { useLocation } from '@remix-run/react';
import { ReactNode, useEffect, useRef } from 'react';

interface AnalyticsWrapperProps {
  children: ReactNode;
}

export function AnalyticsWrapper({ children }: AnalyticsWrapperProps) {
  const { setContext, trackPageView } = useAnalytics();
  const location = useLocation();
  const previousLocation = useRef<string>('');

  // Track anonymous users - could be enhanced with actual user data when available
  useUserTracking();

  // Set additional context for better error tracking
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setContext('application', {
        name: 'growdash-website',
        environment: process.env.NODE_ENV || 'development',
        version: '1.0.0'
      });
    }
  }, [setContext]);

  // Custom page tracking for Remix (client-side only)
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const currentPath = location.pathname + location.search;

      // Only track if the location actually changed
      if (currentPath !== previousLocation.current) {
        trackPageView({
          page: currentPath,
          path: location.pathname,
          title: document.title,
          properties: {
            search: location.search,
            hash: location.hash,
            referrer: document.referrer,
            timestamp: new Date().toISOString()
          }
        });
        previousLocation.current = currentPath;
      }
    }
  }, [location, trackPageView]);

  return <>{children}</>;
}
